<template>
  <div class="content-body customers-wrapper transaction-history soa-wrap">
    <b-row>
      <b-col sm="6">
        <h5>Billing Information</h5>
        <h6 class="mt-3">Ref. No. 00000001 | August 21, 2018</h6>
      </b-col>
      <b-col sm="6" class="text-left text-md-right">
        <b-col class="text-left text-md-right">
          <b-button variant="primary btn-table-add transparent">Download SOA</b-button>
          <b-button variant="primary btn-table-add" v-b-modal="'bill-payment'">Submit Payment</b-button>
        </b-col>
      </b-col>
    </b-row>
    <b-row class="soa mt-2">
      <b-col>
        <b-row>
          <b-col sm="12" lg="7" class="statement-summary">
            <b-row class="heading">
              <b-col>
                <h5>Bistro Group</h5>
                <p>Food</p>
                <p>W Global Center 9Th Ave Cor 30Th St Bgc Brgy Fort Bonifacio, Taguig City</p>
                <p>02-9876543</p>
              </b-col>
            </b-row>
            <b-row class="body table mt-4">
              <b-col>
                <b-row class="header">
                  <b-col sm="12">
                    <h5>Statement Summary</h5>
                  </b-col>
                </b-row>
                <b-row class="item">
                  <b-col sm="6">
                    <h6>Previous Charge Bills</h6>
                  </b-col>
                  <b-col sm="6" class="amount">
                    <h6>Amount</h6>
                  </b-col>
                </b-row>
                <b-row class="item">
                  <b-col sm="6">
                    <p>Amount Due from Previous Bill</p>
                  </b-col>
                  <b-col sm="6" class="amount">
                    <p>11,076.10</p>
                  </b-col>
                </b-row>
                <b-row class="item">
                  <b-col sm="6">
                    <p>Less Payments</p>
                  </b-col>
                  <b-col sm="6" class="amount">
                    <p>(0.00)</p>
                  </b-col>
                </b-row>
                <b-row class="item">
                  <b-col sm="6">
                    <p>Remaining Balance from Previous Bill</p>
                  </b-col>
                  <b-col sm="6" class="amount">
                    <p>12,712.75</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <b-col sm="12" lg="5" class="account-summary">
            <b-row>
              <b-col sm="12">
                <h5>Account Summary</h5>
              </b-col>
            </b-row>
            <b-row>
              <b-col sm="12" class="mt-4 acctNumber">
                <h6 class="label">Account Number</h6>
                <h6>0190-487846-0816</h6>
                <img src="@/assets/images/bar-code.png" alt="">
              </b-col>
            </b-row>
            <b-row class="amounts mt-3">
              <b-col>
                <b-row class="item top">
                  <b-col sm="6" class="label"><span>Outstanding Balance</span></b-col>
                  <b-col sm="6" class="amount">
                    <span>119,838.60</span>
                    <span class="mt-2 note">as of May 1, 2018 11:59:59 PM</span>
                  </b-col>
                </b-row>
                <b-row class="item">
                  <b-col sm="6" class="label"><span>Due Date</span></b-col>
                  <b-col sm="6" class="amount"><span>May 31, 2018</span></b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="amounts mt-3">
              <b-col>
                <b-row class="item top">
                  <b-col sm="6" class="label"><span>My Current Plan</span></b-col>
                  <b-col sm="6" class="amount"><span>Lite</span></b-col>
                </b-row>
                <b-row class="item">
                  <b-col sm="6" class="label"><span>Billing No.</span></b-col>
                  <b-col sm="6" class="amount"><span>190-17</span></b-col>
                </b-row>
                <b-row class="item">
                  <b-col sm="6" class="label"><span>190-17</span></b-col>
                  <b-col sm="6" class="amount"><span>April 1 - April 30, 2018</span></b-col>
                </b-row>
                <b-row class="item bottom">
                  <b-col sm="6" class="label"><span>Statement Date</span></b-col>
                  <b-col sm="6" class="amount"><span>May 1, 2018</span></b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row class="usage-breakdown mt-4">
          <b-col class="table">
            <b-row class="header">
              <b-col sm="12">
                <h5>Usage Breakdown</h5>
              </b-col>
            </b-row>
            <b-row class="item">
              <b-col sm="6">
                <h6>Description</h6>
              </b-col>
              <b-col sm="2" class="amount">
                <h6>Quantity</h6>
              </b-col>
              <b-col sm="2" class="amount">
                <h6>Amount</h6>
              </b-col>
              <b-col sm="2" class="amount">
                <h6>Total</h6>
              </b-col>
            </b-row>
            <b-row class="item">
              <b-col sm="6">
                <p>Monthly Service Fee</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>Service Fee</p>
                  </b-col>
                  <b-col sm="12" class="sub-item">
                    <p>Globe SKU’s Redemption</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="2" class="amount">
                <p>&nbsp;</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>1</p>
                  </b-col>
                  <b-col sm="12" class="sub-item">
                    <p>1</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="2" class="amount">
                <p>&nbsp;</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>1000.00</p>
                  </b-col>
                  <b-col sm="12" class="sub-item">
                    <p>1000.00</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="2" class="amount">
                <p>&nbsp;</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>1000.00</p>
                  </b-col>
                  <b-col sm="12" class="sub-item">
                    <p>1000.00</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="item">
              <b-col sm="6">
                <p>Add Ons</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>Service Fee</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="2" class="amount">
                <p>&nbsp;</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>3 MB</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="2" class="amount">
                <p>&nbsp;</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>4.18</p>
                  </b-col>
                </b-row>
              </b-col>
              <b-col sm="2" class="amount">
                <p>&nbsp;</p>
                <b-row>
                  <b-col sm="12" class="sub-item">
                    <p>3.76</p>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row class="item">
              <b-col sm="6">
                <p>VAT</p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p>12,712.75</p>
              </b-col>
            </b-row>
            <b-row class="item">
              <b-col sm="6">
                <p>Total Current Bill</p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p>12,712.75</p>
              </b-col>
            </b-row>
            <b-row class="item">
              <b-col sm="6">
                <p>Total Previous Bill</p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p>12,712.75</p>
              </b-col>
            </b-row>
            <b-row class="item">
              <b-col sm="6">
                <p>Total Amount Due</p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p></p>
              </b-col>
              <b-col sm="2" class="amount">
                <p>12,712.75</p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
    <b-modal id="bill-payment" class="modal-form modal-bill-payment" size="lg modal-lg" title="Bill Payment">
      <b-container class="container" fluid>
        <b-row class="mt-3 payment-method">
          <b-col sm="12">
            <h6>Choose your payment method:</h6>
            <b-tabs class="mt-3">
              <b-tab title="" class="first" active>
              </b-tab>
              <b-tab title="Pay with Credit Card" class="card">
                <b-row class="mt-3">
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col md="8" class="mt-4">
                    <h6>Enter payment details:</h6>
                    <b-form-group label="Amount to Pay" label-for="cardAmount" class="sl-helper paidAmt mt-4">
                      <span class="icon"><img src="../../assets/images/peso.svg" alt="Peso"></span>
                      <b-form-input id="cardAmount" type="number" placeholder=""></b-form-input>
                    </b-form-group>
                    <b-form-group label="Card Type" label-for="cardType" class="sl-helper">
                      <b-input-group id="cardType">
                        <b-form-select v-model="selectedCard">
                          <option :value="null" selectedCard>VISA</option>
                          <option value="b">Option B</option>
                        </b-form-select>
                      </b-input-group>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Pay with GCash" class="gcash">
                <b-row class="mt-3">
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col md="8" class="mt-4">
                    <h6>Enter payment details:</h6>
                    <b-form-group label="Amount to Pay" label-for="cardAmount" class="sl-helper paidAmt mt-4">
                      <span class="icon"><img src="../../assets/images/peso.svg" alt="Peso"></span>
                      <b-form-input id="cardAmount" type="number" placeholder=""></b-form-input>
                    </b-form-group>
                    <b-form-group label="GCash No." label-for="gcashno" class="sl-helper mt-4">
                      <b-form-input id="gcashno" type="number" placeholder="+63"></b-form-input>
                    </b-form-group>
                  </b-col>
                </b-row>
              </b-tab>
              <b-tab title="Pay via Bank Deposit" class="deposit">
                <b-row class="mt-3">
                  <b-col cols="12">
                    <hr>
                  </b-col>
                  <b-col cols="8" class="mt-4">
                    <h6>Enter payment details:</h6>
                    <b-form-group label="Paid Amount" label-for="paidAmt" class="sl-helper paidAmt mt-4">
                      <span class="icon"><img src="../../assets/images/peso.svg" alt="Peso"></span>
                      <b-form-input id="paidAmt" type="number" placeholder=""></b-form-input>
                    </b-form-group>
                    <b-form-group label="Bank Reference No." label-for="bankRefNo" class="sl-helper">
                      <b-form-input id="bankRefNo" type="number" placeholder=""></b-form-input>
                    </b-form-group>
                    <b-form-group class="mb-1">
                      <label for="date" class="secondary-label align-top">Date</label>
                      <div class="custom-datepicker mb-3 muli-sb">
                        <SingleDatepicker :bootstrap-styling="true" ref="programaticOpen"
                          wrapper-class="custom-datepicker" style="color: #2a2a2a !important;">
                          <div slot="afterDateInput" class="input-group-append pr-0">
                            <span class="input-group-text">
                              <img @click="openPicker" src="../../assets/images/icons/calendar.svg" alt="Calendar Icon"
                                class="form-icon action-button">
                            </span>
                          </div>
                        </SingleDatepicker>
                      </div>
                    </b-form-group>
                    <b-form-group label="Deposit Slip" label-for="depositSlip" class="sl-helper account select-file">
                      <b-form-file id="depositSlip" accept="image/jpeg, image/png, image/gif"
                        placeholder="upload png, jpg, gif"></b-form-file>
                    </b-form-group>
                  </b-col>
                </b-row>
                <b-row class="mt-4 how-to-pay">
                  <b-col>
                    <h6>How to Pay</h6>
                    <p class="mt-4">Payment may be deposited at any BPI branch with the following
                      details:</p>

                    <div class="mt-4 howto-item">
                      <p>Bank:</p>
                      <p><b>BPI : Bank of the Philippine Islands</b></p>
                    </div>
                    <div class="mt-4 howto-item">
                      <p>Account Name:</p>
                      <p><b>Globe Telecom</b></p>
                    </div>
                    <div class="mt-4 howto-item">
                      <p>Bank Account No:</p>
                      <p><b>1891004601</b></p>
                    </div>
                    <div class="mt-4 howto-item">
                      <p>Bank Account Type: </p>
                      <p><b>Current</b></p>
                    </div>
                    <div class="mt-4 notes">
                      <p>Reference Number Format: PNC/PR23/YYYYMMDD</p>

                      <p>Example:* If payment is deposited on Feb 20, 2018
                        reference number will be: PNC/PR23/20160220</p>

                      <p>Check payments must be payable to "Globe Telecom".
                        At the back of the check, write RUSH account number,
                        account name, authorized contact person, and telephone number.</p>

                      <p>Deposits via check from other issuing banks must be paid
                        at least 3 days before due date for clearing.</p>

                      <p>Deposit slip should be uploaded into your Web Dashboard
                        or emailed to <b>billing@rush.com.ph</b> once payment has been made.</p>
                    </div>
                  </b-col>
                </b-row>
              </b-tab>
            </b-tabs>
          </b-col>
        </b-row>
      </b-container>
    </b-modal>
  </div>
</template>

<script>
import "../../plugins/vue-currency-filter";
import Datepicker from "vue-bulma-datepicker";
import SingleDatepicker from "vuejs-datepicker";
const billingAccount = [
  {
    account_no: "0000001",
    outstanding_balance: "PHP 1200.00",
    due_date: "Aug 1, 2018",
    business_name: "Bistro Group",
    location: "BGC",
    representative: "Jose Rizal"
  },
  {
    account_no: "0000002",
    outstanding_balance: "PHP 2400.25",
    due_date: "Aug 2, 2018",
    business_name: "Bistro Group 2",
    location: "Makati",
    representative: "Andres Bonifacio"
  }
];
export default {
  name: "BillingAccount",
  components: {
    Datepicker,
    SingleDatepicker
  },
  data() {
    return {
      selectedCard: null,
      billingAccount: billingAccount,
      currentPage: 1,
      perPage: 10,
      totalRows: billingAccount.length,
      fields: [
        {
          key: "account_no",
          label: "Account No.",
          sortable: true
        },
        {
          key: "outstanding_balance",
          label: "Outstanding Balance",
          sortable: true
        },
        {
          key: "due_date",
          label: "Due Date",
          sortable: true
        },
        {
          key: "business_name",
          label: "Business Name",
          sortable: true
        },
        {
          key: "location",
          label: "Location",
          sortable: true
        },
        {
          key: "representative",
          label: "Representative",
          sortable: true
        }
      ],
      daterangeConfig: {
        altInput: true,
        altFormat: "M j, Y",
        dateFormat: "Y-m-d",
        static: true,
        mode: "range",
        defaultDate: ["today", "today"]
      }
    };
  }
};
</script>
